import gql from 'graphql-tag';

import ContestEntryItemFragment from './ContestEntryItem';
import EmailSignupItemFragment from './EmailSignupItem.gql';
import FaqItemFragment from './FaqItem';
import GalleryItemFragment from './GalleryItem';
import HtmlItemFragment from './HtmlItem.gql';
import ImageItemFragment from './ImageItem';
import ImageSliderItemFragment from './ImageSliderItem';
import ListicleItemFragment from './ListicleItem';
import ProductEmbedItemFragment from './ProductEmbedItem';
import ProductItemFragment from './ProductItem';
import ProductTeaserItemFragment from './ProductTeaserItem';
import ProductTeaserListItemFragment from './ProductTeaserListItem';
import ProfileItemFragment from './ProfileItem.gql';
import RecipeCollectionItemFragment from './RecipeCollectionItemFragment';
import RecipeItemFragment from './RecipeItem.js';
import SearchItemFragment from './SearchItem.gql';
import SideBySideItemFragment from './SideBySideItem';
import SubsectionNavFragment from './SubsectionNavFragment';
import TeaserItemFragment from './TeaserItem.gql';
import TipFragment from './Tip.gql';
import ThirdPartyItemFragment from './ThirdPartyItem.gql';
import UnknownItemFragment from './UnknownItem.gql';
import VideoItemFragment from './VideoItem.gql';
// Unused
// import ProfileItemFragment from './ProfileItem.gql';

export default gql`
  fragment ContentItemsFragment on ContentBundleItem {
    ...ContestEntryItemFragment
    ...EmailSignupItemFragment
    ...FaqItemFragment
    ...GalleryItemFragment
    ...HtmlItemFragment
    ...ImageItemFragment
    ...ImageSliderItemFragment
    ...ListicleItemFragment
    ...ProductEmbedItemFragment
    ...ProductItemFragment
    ...ProductTeaserItemFragment
    ...ProductTeaserListItemFragment
    ...ProfileItemFragment
    ...RecipeCollectionItemFragment
    ...RecipeItemFragment
    ...SearchItemFragment
    ...SideBySideItemFragment
    ...SubsectionNavFragment
    ...TeaserItemFragment
    ...TipFragment
    ...ThirdPartyItemFragment
    ...UnknownItemFragment
    ...VideoItemFragment
  }
  ${ContestEntryItemFragment}
  ${EmailSignupItemFragment}
  ${FaqItemFragment}
  ${GalleryItemFragment}
  ${HtmlItemFragment}
  ${ImageItemFragment}
  ${ImageSliderItemFragment}
  ${ListicleItemFragment}
  ${ProductEmbedItemFragment}
  ${ProductItemFragment}
  ${ProductTeaserItemFragment}
  ${ProductTeaserListItemFragment}
  ${ProfileItemFragment}
  ${RecipeCollectionItemFragment}
  ${RecipeItemFragment}
  ${SearchItemFragment}
  ${SideBySideItemFragment}
  ${SubsectionNavFragment}
  ${TeaserItemFragment}
  ${TipFragment}
  ${ThirdPartyItemFragment}
  ${UnknownItemFragment}
  ${VideoItemFragment}
`;
